import angular from "angular";
import { QpuiInputNumberDirective } from "./qpui-input-number.directive";

import '@qp-utils/qp-input-regular';
import { QpuiNumberRegularDirective } from "./qpui-number-regular.directive";

let module_name = "qpui.bootstrap.inputNumber";

let inputNumberModule = angular.module(module_name, ["qp.core.commons.utils"]);

inputNumberModule.directive({
    qpuiInputNumber: QpuiInputNumberDirective,
    qpuiNumberRegular:QpuiNumberRegularDirective
})

export { inputNumberModule, module_name }